module.exports = __webpack_public_path__ + "img/yhteysaluslaituri_original.3620fa93.jpg";